module.exports = __webpack_public_path__ + "img/mt_clickbait_style_lightbulb.a2eb33de.svg";